import { useEffect } from "react";
import { ToastBadge, ToastBadgeTitle } from "./styles";

export interface InlineToastProps {
  title: string;
  duration?: number;
  onClose: () => void;
}

/**
 * Componente presentacional para mostrar un Toast embebido.
 * Maneja internamente su propio tiempo de vida y llama a onClose al terminar.
 */
export const InlineToast = ({ title, duration = 2500, onClose }: InlineToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <ToastBadge $inline>
      <ToastBadgeTitle>{title}</ToastBadgeTitle>
    </ToastBadge>
  );
};
